import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import { topicManagement } from "../../../utils/mainTabs/organize/topicManagement";
import { addGroupTopic } from "../../../utils/mainTabs/organize/addGroupTopic";

import classes from "./TopicManagement.module.scss";
import TopicTable from "./TopicTable/TopicTable";
import { addNewTopic } from "../../../utils/mainTabs/organize/addNewTopic";
import GroupTopicTable from "./GroupTopicTable/GroupTopicTable";
import { FormattedMessage } from "react-intl";
import { getAllProgramsActionHandler } from "../../../store/actions/actionHandlers/distributeActionHandler";

const TopicManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const routerParams = useParams();
  const [activeTab, setActiveTab] = useState("groupTopic");
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const {
    groupTopicTiles,
    setGroupTopicTiles,
    seriesMgmtTiles,
    createNewTopicPath,
    createGroupTopicPath,
    createGroupTopicEditPath,
    tenantName,
    topicEditPath
  } = useOutletContext();

  const handleTab1 = () => {
    // update the state to group topic
    setActiveTab("groupTopic");
  };
  const handleTab2 = () => {
    // update the state to topic
    setActiveTab("topic");
  };
  useEffect(() => {
    dispatch(
      getAllProgramsActionHandler("WithoutVTLT", "Published", "ShotClass")
    );
    dispatch(
      getAllProgramsActionHandler("WithoutVTLT", "Published", "Program")
    );
    dispatch(
      getAllProgramsActionHandler("WithoutVTLT", "Published", "Collection")
    );
  }, [dispatch]);
  return location.pathname === topicManagement.path(tenantName) ? (
    <div className={classes.topicMgmtMain}>
      <div className={classes.tabsAndGroupTopicLink}>
        <div className={classes.tabsLinks}>
          <ul className={classes.nav}>
            <li
              className={activeTab === "groupTopic" ? classes.active : ""}
              onClick={handleTab1}
            >
              Topic
            </li>
            <li
              className={activeTab === "topic" ? classes.active : ""}
              onClick={handleTab2}
            >
              Subtopic
            </li>
          </ul>
        </div>
        <div className={classes.groupTopicLink}>
          {activeTab === "groupTopic" ? (
            <div
              className={classes.addGroupTopic}
              onClick={() =>
                navigate(
                  `${addGroupTopic.path(location, routerParams, tenantName)}/details`
                )
              }
            >
              <AddIcon fill={colors?.theme} />
              Add New Topic
            </div>
          ) : (
            <div
              className={classes.addNewTopic}
              onClick={() =>
                navigate(`${addNewTopic.path(location, routerParams, tenantName)}/details`)
              }
            >
              <AddIcon fill={colors?.theme} />
              {/* <FormattedMessage id="ADDNEWTOPIC_TEXT" /> */}
              Add New Subtopic
            </div>
          )}
        </div>
      </div>
      <div className={classes.dataTableMain}>
        {activeTab === "groupTopic" ? (
          <div className={classes.groupTopicInner}>
            <GroupTopicTable />
          </div>
        ) : (
          <TopicTable />
        )}
      </div>
    </div>
  ) : (
    <Outlet
      context={{
        groupTopicTiles,
        setGroupTopicTiles,
        seriesMgmtTiles,
        createNewTopicPath,
        createGroupTopicPath,
        createGroupTopicEditPath,
        tenantName,
        topicEditPath
      }}
    />
  );
};

export default TopicManagement;
